export const BLOG = 'blog-all';
export const BLOG_ALL = 'all';
export const TYPE_BLOG = '/blog';
